export default __webpack_public_path__ + "assets/pdf/FT_API_609.b4130816.pdf";